import { CosmicPageClientProvider } from '@omaze/cms';
import {
    ICartItem,
    IEspClient,
    useEspClient,
} from '@omaze/email-marketing';
import React, { ReactElement, useEffect } from 'react';

import { IShopifyCartItem } from '../../data-sources/shopify-client/IShopifyCartItem';
import { COOKIE_GROUPS } from '../../shared/CookieCompliance/constants';
import { cookiesPermitted } from '../../shared/CookieCompliance/cookieCompliance';
import { Portal } from '../../shared/Portal/Portal.component';

import { HDYHAU } from './HDYHAU/HDYHAU';

export function Cart (): ReactElement | null {
    const espClient: IEspClient | null = useEspClient();
    const userEmail: string = window.shopifyUser.email;
    const shopifyCartItems: IShopifyCartItem[] = window.ozShopifyApp.cart.items;
    const shopOriginURL: string = window.ozShopifyApp.shopOriginURL;

    useEffect((): void => {
        const targetingCookiesPermitted: boolean = cookiesPermitted(COOKIE_GROUPS.TARGETING);

        if (espClient && userEmail && targetingCookiesPermitted) {
            const cartItems: ICartItem[] = shopifyCartItems.map((item: IShopifyCartItem): ICartItem => {
                return {
                    id: item.id,
                    qty: item.quantity,
                    price: item.price,
                    title: item.title,
                    image: item.image,
                    url: `${shopOriginURL}${item.url}`,
                };
            });

            espClient.updateCart({
                email: userEmail,
                cartItems: cartItems,
            }).catch((err: any): void => {
                // eslint-disable-next-line  no-console
                console.error(`${err}`);
            });
        }
    }, []);

    return (
        <Portal el="cart-app__hdyhau">
            <CosmicPageClientProvider bucket={window.ozShopifyApp.dataSources.cosmic.bucket}>
                <HDYHAU />
            </CosmicPageClientProvider>
        </Portal>
    );
}
